export enum VideoLoadingState {
    LOADING = "LOADING",
    LOADED = "LOADED",
    ERROR = "ERROR"
}